import {
  Button,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";
import { InformationContainer } from "../welcomeBanner/WelcomeBanner.styled";
import { SvgDotPattern2 } from "./MembersDetailsContainer.styled";
import { ReactComponent as RenewButtonIcon } from "feather-icons/dist/icons/refresh-cw.svg";

import {
  InformationContainerInner,
  SpondGroupContainer,
} from "../SpondGroups/SpondGroups.styles";
import React from "react";
import MemberDetails from "components/account/privilegedViews/MemberDetails";

const MemberDetailsContainer = ({
  membershipNumber,
  isAdult,
  memberDetails,
  refreshMember,
}) => {
  const initialFocusRef = React.useRef();

  const toMembershipPayment = function () {
    if (isAdult) {
      window.location.href =
        process.env.REACT_APP_SENIORS_PAYMENT_LINK +
        "?client_reference_id=" +
        membershipNumber;
    } else {
      window.location.href =
        process.env.REACT_APP_JUNIORS_PAYMENT_LINK +
        "?client_reference_id=" +
        membershipNumber;
    }
  };

  return (
    <InformationContainer>
      <SvgDotPattern2 />
      <InformationContainerInner></InformationContainerInner>

      <MemberDetails
        memberDetails={memberDetails}
        refreshMemberDetails={refreshMember}
        isEditable={true}
        sectionTitle={"Membership Details"}
      />

      <SpondGroupContainer>
        {(memberDetails.membershipStatus === "EXPIRING" ||
          memberDetails.membershipStatus === "EXPIRED") && (
          <Popover
            initialFocusRef={initialFocusRef}
            placement="bottom"
            closeOnBlur={false}
          >
            <PopoverTrigger>
              <Button
                style={{ marginTop: "10px" }}
                colorScheme="red"
                size={"lg"}
                leftIcon={<RenewButtonIcon />}
              >
                RENEW
              </Button>
            </PopoverTrigger>
            <PopoverContent color="white" bg="blue.800" borderColor="blue.800">
              <PopoverHeader pt={4} fontWeight="bold" border="0">
                Terms and Conditions
              </PopoverHeader>
              <PopoverArrow bg="blue.800" />
              <PopoverCloseButton />
              <PopoverBody>
                By renewing your membership you agree to the club constitution,
                policies and code of conduct{" "}
                <Link
                  target="_blank"
                  href="/documents"
                  textDecoration={"underline"}
                >
                  found here
                </Link>
                . Furthermore you will be auto enrolled in the club
                championships, and your name will be provided to race
                organisers, whose races are included in the club championships.
                The race organiser may in turn provide your race result back to
                the club championships organiser for easy processing.
              </PopoverBody>

              <PopoverFooter
                border="0"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                pb={4}
              >
                <Button
                  style={{ marginTop: "10px" }}
                  colorScheme="red"
                  size={"lg"}
                  leftIcon={<RenewButtonIcon />}
                  onClick={toMembershipPayment}
                >
                  RENEW
                </Button>
              </PopoverFooter>
            </PopoverContent>
          </Popover>
        )}
      </SpondGroupContainer>
    </InformationContainer>
  );
};

export default MemberDetailsContainer;
